<script>
    import { metaInfo } from "@/core/MetaInfo";
    import BaseButton from "@main/packages/BaseButton";
    import TypographyWrapper from "@/components/TypographyWrapper";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";

    export default {
        name: "Wholesale",
        components: { LinkWithAnalytics, BaseButton, TypographyWrapper },
        metaInfo() {
            return metaInfo.getMeta("wholesale");
        },
    };
</script>

<template>
    <div class="wholesale-page">
        <div class="l-container">
            <typography-wrapper>
                <h1 class="page-title">Оптовая продажа</h1>

                <div class="wholesale-page__text">
                    <p>
                        Хотите продавать ZAVTRA у&nbsp;себя? Весь ассортимент доступен
                        и&nbsp;для оптовых заказов. Нам есть что предложить как торговым сетям,
                        так и&nbsp;маленьким бутикам.
                    </p>
                    <p>
                        Сделать заказ или задать вопросы можно по&nbsp;почте&nbsp;&mdash;
                        <link-with-analytics type="email" text="lk@zavtra.co">
                            lk@zavtra.co
                        </link-with-analytics>
                        или в&nbsp;telegram:
                        <a href="http://telegram.me/fraugud" target="_blank">fraugud</a>.
                    </p>
                </div>

                <base-button
                    class="wholesale-page__button"
                    variant="v1"
                    size="lg"
                    @click="$router.push({ name: 'Home', hash: '#catalog' })"
                >
                    Перейти к покупкам
                </base-button>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .wholesale-page {
        flex-grow: 1;
        padding-bottom: 40px;
        button {
            margin: 0 auto;
        }
        @include bp($bp-desktop-sm) {
            padding-bottom: 56px;
        }
    }

    .wholesale-page__text {
        margin-bottom: 20px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            max-width: 900px;
            margin: 0 auto 20px;
        }
    }

    .wholesale-page__button {
        width: 100%;
        max-width: 320px;
    }
</style>
